import { autoinject, bindable } from 'aurelia-framework';
import { SideBar, ISideBarButton } from './side-bar';

@autoinject
export class SideBarButton implements ISideBarButton {
	@bindable key = 'side-bar-1';
	@bindable buttonClass = 'btn-menu';
	@bindable resourceText;

	toggleButtonClass: string;
	active = false;

	constructor(private sideBar: SideBar) {
		this.sideBar.addButton(this);
	}

	attached() {
		this.toggleButtonClass = this.buttonClass;
	}

	show(event: Event) {
		this.sideBar.showContainer(this.key);
		this.active = true;

		event.stopPropagation();
	}

	resetClass() {
		this.active = false;
	}
}
